// Pure month/day recurrence math shared by anything that announces a "next
// occurrence of this date every year" event — birthdays, work anniversaries,
// and whatever else gets added later. Neither function cares what the event
// actually is, just the month/day.

// Days from `todayDateStr` ("YYYY-MM-DD") to the next occurrence of
// month/day, rolling into next year if this year's date has already passed.
export function daysUntilAnnualDate(month, day, todayDateStr) {
  const today = new Date(`${todayDateStr}T00:00:00.000Z`);
  const year = today.getUTCFullYear();
  let next = new Date(Date.UTC(year, month, day));
  if (next < today) next = new Date(Date.UTC(year + 1, month, day));
  return Math.round((next - today) / (24 * 60 * 60 * 1000));
}

// The calendar year the next occurrence of month/day actually falls in —
// needed on top of daysUntilAnnualDate whenever the caller also needs to
// know "how many years since X" (e.g. a work anniversary's year count).
export function yearOfNextOccurrence(month, day, todayDateStr) {
  const today = new Date(`${todayDateStr}T00:00:00.000Z`);
  const year = today.getUTCFullYear();
  const thisYear = new Date(Date.UTC(year, month, day));
  return thisYear < today ? year + 1 : year;
}

export function formatAnnualDate(month, day) {
  return new Date(Date.UTC(2001, month, day)).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
